import React from 'react';
import {Outlet} from 'react-router-dom';
import cn from 'classnames'

import Header from '../Header/Header';

import bg_img from './cake.png';
import gradient from './gradient.jpg'

import cls from './IndexLayout.module.scss';

const IndexLayout = () => (
    <div className={cls.layout} style={{backgroundImage: `url(${gradient})`}}>

        <Header/>

        <div className={cls.content}>

            <div className={cn(['content', cls.page])}>
                <h2 className={cls.title}>10 июля – День S7 Technics 🎉
                    Викторина с подарками!</h2>

                <div className={cls.cake} style={{backgroundImage: `url(${bg_img})`}}/>

                <Outlet/>
            </div>
            
        </div>

    </div>
)

export default IndexLayout